import { Pair, createBrandedPair } from '@deltasierra/type-utilities';
import { HasId } from '../common';
import { PlatformId } from '../platform/Platform';
import { ClientId } from './ClientId';

export type ClientPlatformConfigurationId = Pair<ClientId, PlatformId>;
export const ClientPlatformConfigurationId = createBrandedPair<ClientPlatformConfigurationId>();

export interface ClientPlatformConfiguration extends HasId<ClientPlatformConfigurationId> {
    name: string;

    label: string;

    isEnabled: boolean;

    isConfigured: boolean;

    isRequired: boolean;
}
